import { Component, OnInit } from '@angular/core';

import { POLICY } from './policy';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent implements OnInit {
  data = POLICY;

  constructor(private tSrv: Title) { }

  ngOnInit(): void {
    this.tSrv.setTitle('Privacy Policy | Don\'t Waste Money');
  }

}
